import type { FilterItemType } from '@app/components/VisitsHistory/types';

export const filterItems: Array<FilterItemType> = [
  {
    key: 1,
    title: 'Все визиты',
    value: 'all-visits',
    testId: 'all-visits',
  },
  {
    key: 2,
    title: 'Визиты без оплат',
    value: 'visits-without-payment',
    testId: 'visits-without-payment',
  },
];

export const columns = [
  {
    key: 1,
    title: 'Исполнитель',
    className: 'visits-table_th_performer',
    testId: 'performer',
  },
  {
    key: 2,
    title: 'Статус',
    className: 'visits-table_th_status',
    testId: 'status',
  },
  {
    key: 3,
    title: 'Услуги',
    className: 'visits-table_th_services',
    testId: 'services',
  },
  {
    key: 4,
    title: 'Стоимость',
    className: 'visits-table_th_cost',
    testId: 'cost',
  },
  {
    key: 5,
    title: 'Оплачено',
    className: 'visits-table_th_paid',
    testId: 'paid',
  },
];
